import axios from '@/plugins/axios'
import { Module } from 'vuex'

const timezoneModule: Module<any, any> = {
    state: {},

    actions: {
        async getTimezones({ commit }, params) {
            const indexExists = await this.dispatch('indexExists', 'timezone')

            if (!indexExists) {
                await this.dispatch('initIndex', {
                    id: 'timezone',
                    idField: 'zoneId',
                    indexedFields: ['countryCode', 'zoneName'],
                    source: '/api/timezones',
                })
            }

            let records = await this.dispatch('getRecords', {
                index: 'timezone',
            })

            return records
        },
    },

    mutations: {},
}

export default timezoneModule
